import { useState } from 'react';

const useSharedArray = (initialState) => {
    const [state, setArrayState] = useState(initialState);
    const [selectedPlayers, setSelectedPlayers] = useState([]);
    const [remainingPlayers, setRemainingPlayers] = useState([]);

    function updateArrayState(items) {
        const diff = items.filter(i => !selectedPlayers.includes(i));
        const newSelectedPlayers = [...selectedPlayers, ...diff];
        setSelectedPlayers(newSelectedPlayers);
        setRemainingPlayers(state.filter(i => !newSelectedPlayers.includes(i)));
    }

    function setInitialState(items) {
        setArrayState(items);
        setRemainingPlayers(items);
    }

    return {
        remainingPlayers,
        setInitialState,
        updateArrayState
    }
}

export default useSharedArray;